module.exports = __webpack_public_path__ + "static/media/PUSHER.76ed9a6b.svg";